.af-modal {
  position: fixed;
  inset: 0;
  z-index: var(--z-overlay);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-4);
}

.af-modal__backdrop {
  position: absolute;
  inset: 0;
  background: var(--color-text);
  opacity: 0.45;
  animation: af-fade-in var(--duration-base) var(--ease-enter);
}

.af-modal__panel {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - var(--space-6));
  width: 100%;
  background: var(--color-surface);
  color: var(--color-text);
  border: var(--border-width) solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-3);
  animation: af-dialog-in var(--duration-base) var(--ease-enter);
}

.af-modal__panel:focus-visible {
  outline: var(--focus-width) solid var(--color-focus);
  outline-offset: var(--focus-offset);
}

.af-modal__panel--sm {
  max-width: 26rem;
}

.af-modal__panel--md {
  max-width: 36rem;
}

.af-modal__panel--lg {
  max-width: 52rem;
}

.af-modal--drawer {
  justify-content: flex-end;
  align-items: stretch;
  padding: 0;
}

.af-modal--drawer.af-modal--left {
  justify-content: flex-start;
}

.af-modal--drawer .af-modal__panel {
  max-height: none;
  height: 100%;
  border-radius: 0;
  animation-name: af-drawer-in-right;
}

.af-modal--drawer.af-modal--left .af-modal__panel {
  animation-name: af-drawer-in-left;
}

.af-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-5) var(--space-5) var(--space-3);
}

.af-modal__title {
  margin: 0;
  font-size: var(--text-xl);
  font-weight: var(--weight-semibold);
  line-height: var(--leading-tight);
  letter-spacing: var(--tracking-tight);
}

.af-modal__description {
  margin: var(--space-1) 0 0;
  color: var(--color-text-muted);
}

.af-modal__body {
  padding: 0 var(--space-5) var(--space-5);
  overflow-y: auto;
}

.af-modal__footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: var(--space-2);
  padding: var(--space-4) var(--space-5);
  border-top: var(--border-width) solid var(--color-border);
}

@keyframes af-fade-in {
  from {
    opacity: 0;
  }
}

@keyframes af-dialog-in {
  from {
    opacity: 0;
    transform: translateY(var(--space-3)) scale(0.98);
  }
}

@keyframes af-drawer-in-right {
  from {
    transform: translateX(100%);
  }
}

@keyframes af-drawer-in-left {
  from {
    transform: translateX(-100%);
  }
}
